module.exports = ".body-wrap, .body-container {\r\n\twidth: 100%;\r\n\theight: 100%;\r\n}\r\n\r\n\r\n#request-indicator {\r\n\tposition: fixed;\r\n\ttop: 50%;\r\n\tleft: 50%;\r\n\t-webkit-transform: translateX(-50%) translateY(-50%);\r\n\t        transform: translateX(-50%) translateY(-50%);\r\n\twidth: 100px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main